import React from 'react';

var SvgPayoutPoundIcon = function SvgPayoutPoundIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5c-3.038 0-5.5 2.462-5.5 5.5 0 .915.223 1.777.617 2.534.191.368.048.82-.32 1.012-.367.19-.82.048-1.01-.32-.503-.966-.787-2.064-.787-3.226 0-3.866 3.134-7 7-7s7 3.134 7 7c0 1.162-.284 2.26-.786 3.226-.192.368-.644.51-1.012.32-.367-.191-.51-.644-.32-1.012.395-.757.618-1.619.618-2.534 0-3.038-2.462-5.5-5.5-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.5c.414 0 .75.336.75.75s-.336.75-.75.75h-13c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 6.5c-.966 0-1.75.784-1.75 1.75v1.495l-.508.005c-.414.004-.746.344-.742.758.004.414.344.746.758.742l.492-.005v.755h-.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.5v-.755l.492.005c.414.004.754-.328.758-.742.004-.414-.328-.754-.742-.758l-.508-.005v-1.495c0-.138.112-.25.25-.25h.5v.5c0 .414.336.75.75.75s.75-.336.75-.75v-.75c0-.69-.56-1.25-1.25-1.25h-.75Z"
  }));
};
SvgPayoutPoundIcon.displayName = "PayoutPoundIcon";

export { SvgPayoutPoundIcon as S };
